export const requestUpdatePermission = (clientId, permission) => {
  return {
    clientId: clientId,
    permissionId: permission._id,
  };
};
